import { http } from '../../config/axios'

const graficoDashboardRepresentante = (): Promise<any> => {
  return http
    .get('api/dashboard-representante/grafico')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro graficoDashboardRepresentante', error)
      throw Error(error.response.data)
    })
}

export default graficoDashboardRepresentante;
